<div class="row">
	<div class="col-sm-12">
		<div class="card-box clearfix" id="swagger-container">
			<div id="swagger-ui">
				{{TR "API Dokumentation wird initialisiert."}} <i class="fa fa-spin fa-spinner m-t-20"></i>
			</div>
		</div>
	</div>
</div>
